import React from 'react';

import { Text } from '../../../../components';
import { Card, Head, Heading, Suffix } from './SectionCard.styles';

export type SectionCardProps = {
  /** Static heading copy (translation key). */
  title: string;
  /** Optional muted suffix after the title — a natural-language key, e.g.
   *  "• {{count}} Players", with the count supplied via `suffixPlaceholders`. */
  suffix?: string;
  /** i18n interpolation values for the suffix. */
  suffixPlaceholders?: Record<string, string | number>;
  children: React.ReactNode;
};

/**
 * Pulse section shell — the outer card plus a heading ("This month", "Your Asset
 * • 2,184 Players", …). The title renders as a translation key; the optional
 * suffix is a muted, interpolated key sitting inline after it.
 */
export const SectionCard = ({ title, suffix, suffixPlaceholders, children }: SectionCardProps): React.ReactElement => (
  <Card>
    <Head>
      <Heading>
        <Text text={title} tag="span" />
        {suffix ? <Suffix text={suffix} placeholders={suffixPlaceholders} tag="span" /> : null}
      </Heading>
    </Head>
    {children}
  </Card>
);

export default SectionCard;
